export const DEVELOPPEMENTURBAIN = "DEVELOPPEMENTURBAIN";
export const DEVELOPPEMENTECONOMIQUE = "DEVELOPPEMENTECONOMIQUE";
export const MARCHANDISES = "MARCHANDISES";
export const PASSAGERS = "PASSAGERS";
export const POINTS = "POINTS";
export const FOND = "FOND";
export const LIEUX = "LIEUX";
export const EUROMED = "EUROMED";
export const REPARATIONNAVALE = "REPARATIONNAVALE";
export const ACCESFERROVIERE = "ACCESFERROVIERE";
export const PLAISANCEETBALNEAIRE = "PLAISANCEETBALNEAIRE";
export const CARREE = "CARREE";
export const INFRASTRUCTURE = "INFRASTRUCTURE";


const config = {
    serveur: window.location.host === "spot.agam.org" ?
        "https://spot.agam.org/api/bdd/outils/"
        :
        "http://192.168.0.6:3000/api/bdd/outils/",
    serveuradministration: window.location.host === "spot.agam.org" ?
        "https://spot.agam.org/api/bdd/"
        :
        "http://192.168.0.6:3000/api/bdd/",
	maxZoom:20,
	minZoom:5,
	center: [593795, 5362134],
	zoom: 11,
    contenu: JSON.stringify([
        {
            type: PASSAGERS,
            legende: [{ titre: "", typeicone: "points" }],
            titre: 'TERMINAL PORTUAIRES - PASSAGERS',
            afficher: true,
            couleur: 'rgb(133,196,111)'
        },
        {
            type: MARCHANDISES,
            legende: [{ titre: "", typeicone: "points" }],
            titre: 'TERMINAL PORTUAIRES - MARCHANDISES',
            afficher: true,
            couleur: "rgb(104,151,196)"
        },
        {
            type: REPARATIONNAVALE,
            legende: [{ titre: "", typeicone: "points" }],
            titre: 'RÉPARATION NAVALE',
            afficher: true,
            couleur: "rgb(103,182,230)"
        },
        {
            type: DEVELOPPEMENTECONOMIQUE,
            legende: [{ titre: "", typeicone: "points" }],
            titre: 'DÉVELOPPEMENT ÉCONOMIQUE',
            afficher: true,
            couleur: "rgb(146,122,183)"
        },
        {
            type: DEVELOPPEMENTURBAIN,
            legende: [{ titre: "", typeicone: "points" }],
            titre: 'DÉVELOPPEMENT URBAIN',
            afficher: true,
            couleur: 'rgb(248,153,79)'
        },
        {
            type: PLAISANCEETBALNEAIRE,
            legende: [{ titre: "", typeicone: "points" }],
            titre: 'PLAISANCE ET BALNÉAIRE',
            afficher: true,
            couleur: 'rgb(251,225,73)'
        },
        {
            type: INFRASTRUCTURE,
            legende: [{ titre: "", typeicone: "points" }],
            titre: 'INFRASTRUCTURES DE DÉPLACEMENTS',
            afficher: true,
            couleur: 'rgb(189,88,68)'
        }]
    )

}

export default config;